import { createFileRoute, notFound } from "@tanstack/react-router";
import { getArticle, getArticles } from "@/lib/server-functions";
import ArticleDetail from "@/pages/ArticleDetail";
import ogImage from "@/assets/knmc-og.jpeg";
import { getPageUrl } from "@/lib/site";
import { articleJsonLd } from "@/lib/jsonld";

export const Route = createFileRoute("/health-articles/$slug")({
  loader: async ({ params }) => {
    try {
      const [article, articles] = await Promise.all([
        getArticle({ data: params.slug }),
        getArticles(),
      ]);
      return { article, articles };
    } catch {
      throw notFound();
    }
  },

  head: ({ params, loaderData }) => {
    const article = loaderData?.article;

    const title = article?.title || `Health Article — ${params.slug}`;

    const description =
      article?.excerpt ||
      `Read health articles and tips from KNMC specialists in Kathmandu, Nepal.`;

    const keywords =
      article?.meta_keywords ||
      `${title}, health tips Nepal, health articles Kathmandu, KNMC hospital, medical advice Nepal`;

    const pagePath = `/health-articles/${encodeURIComponent(params.slug)}`;
    const pageUrl = getPageUrl(pagePath);

    const imageUrl = getPageUrl(article?.cover || ogImage);

    return {
      meta: [
        { title },
        { name: "description", content: description },
        {
          name: "keywords",
          content: keywords,
        },
        {
          property: "og:title",
          content: `${title} | KNMC Kathmandu`,
        },
        {
          property: "og:description",
          content: description,
        },
        {
          property: "og:image",
          content: imageUrl,
        },
        {
          property: "og:url",
          content: pageUrl,
        },
        ...(article ? [articleJsonLd(article, pagePath)] : []),
      ],

      links: [
        {
          rel: "canonical",
          href: pageUrl,
        },
      ],
    };
  },

  component: () => {
    const { article, articles } = Route.useLoaderData();

    return <ArticleDetail article={article} articles={articles} />;
  },
});